// src/belediye/components/mesajlasma/taslak.js
// FAZ-60 — YARIM KALAN MESAJ (taslak) TEK KAYNAK.
//
// Kullanıcı: "diyelim ki yarıda bir sohbet var, tam yazıyorken kapanmışsa orada
// kalsın, silme; taslak olarak kalsın, sonra kişi oraya tıkladığında ne yazdığını
// görebilsin — yanlışlıkla tıklamaların önüne geçmek için."
//
// Neden gerekli: sohbet penceresi artık ROTA DEĞİŞİNCE de kapanabiliyor
// (kaplayan boylarda) ve ChatThread her sohbet için `key` ile yeniden kuruluyor
// — yani yazılmış ama gönderilmemiş metin, kullanıcı hiçbir şey yapmadan da
// yok olabiliyordu.
//
// NEDEN localStorage (sessionStorage değil): taslak sekme kapansa da yarın
// sabah da durmalı. NEDEN kullanıcı kimliği anahtarda: belediyede ortak
// bilgisayar olağan — B kullanıcısı A'nın yarım cümlesini görmemeli. Sohbet
// gövdeleri sunucuda şifreli tutuluyor; taslağı düz metin ve ortak anahtarla
// bırakmak o özeni boşa çıkarırdı.
//
// Anahtar: msjTaslak:<kullaniciId>:<sohbetId>. Boş metin SATIRI SİLER — biriken
// ölü kayıt olmaz.

const ONEK = "msjTaslak";

const kullaniciId = () => {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    return String(u?.id || u?.pk || "anon");
  } catch {
    return "anon";
  }
};

const anahtar = (convId) => `${ONEK}:${kullaniciId()}:${convId}`;

/** Sohbetin taslağı (yoksa ""). */
export function taslakOku(convId) {
  if (!convId) return "";
  try {
    return localStorage.getItem(anahtar(convId)) || "";
  } catch {
    return "";
  }
}

/** Taslağı yaz; boş/boşluk-only ise SİL. */
export function taslakYaz(convId, metin) {
  if (!convId) return;
  try {
    if (String(metin || "").trim() === "") localStorage.removeItem(anahtar(convId));
    else localStorage.setItem(anahtar(convId), String(metin));
  } catch {
    /* özel sekme / kota — taslak tutulmaz, yazma akışı bozulmaz */
  }
}

export const taslakSil = (convId) => taslakYaz(convId, "");
